export default {
    delivery: {
        product: {
            tracking: "Sendungsverfolgung",
            quantity: "Menge"
        }
    }
}